import React from 'react';
import { DefaultButton } from '@fluentui/react';
import { Icon } from '@fluentui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../../../shared/auth/auth';
import './AdminButton.scss';

interface IAdminButtonProps {
    className?: string;
}

const AdminButton: React.FC<IAdminButtonProps> = ({ className }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const userProfile = auth.getUserProfile();
    const isAdmin = userProfile ? userProfile.isAdmin : false;

    const isAdminRoute = location && location.pathname.startsWith('/admin');
    const isUserDetailsRoute = location && location.pathname === '/userdetails';

    const buttons = [
        ...(isAdminRoute || isUserDetailsRoute ? [{ title: 'Home', iconName: 'Home', path: '/' }] : []),
        ...(isUserDetailsRoute && isAdmin ? [{ title: 'Admin', iconName: 'Admin', path: '/admin/applications' }] : []),
        ...(isAdmin && !isAdminRoute && !isUserDetailsRoute ? [{ title: 'Admin', iconName: 'Admin', path: '/admin/applications' }] : []),
    ];

    if (buttons.length === 0) {
        return null;
    }

    return (
        <>
            {buttons.map(({ title, iconName, path }) => (
                <DefaultButton
                    key={title}
                    className={`AdminButton ${className || ''}`}
                    title={title}
                    ariaLabel={title}
                    /* tslint:disable-next-line:jsx-no-lambda */
                    onClick={() => navigate(path)}
                >
                    <Icon iconName={iconName} />
                </DefaultButton>
            ))}
        </>
    );
};

export default AdminButton;
